
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/manage-groups/jst/groups';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  return "\n  <ul class=\"collectionViewItems unstyled groups-list\"></ul>\n  <div class=\"paginatedLoadingIndicator\"></div>\n";
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <div class=\"no-results\">\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.groups")
  },data:data},helper ? helper.call(depth0, "groups.manage.groups.no_groups", "There are currently no groups in this group set. Add a group to get started.", options) : helperMissing.call(depth0, "t", "groups.manage.groups.no_groups", "There are currently no groups in this group set. Add a group to get started.", options)))
    + "\n  </div>\n";
  return buffer;
  }

  stack1 = (helper = helpers.ifAny || (depth0 && depth0.ifAny),options={hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.collection)),stack1 == null || stack1 === false ? stack1 : stack1.length), ((stack1 = (depth0 && depth0.collection)),stack1 == null || stack1 === false ? stack1 : stack1.fetchingPage), options) : helperMissing.call(depth0, "ifAny", ((stack1 = (depth0 && depth0.collection)),stack1 == null || stack1 === false ? stack1 : stack1.length), ((stack1 = (depth0 && depth0.collection)),stack1 == null || stack1 === false ? stack1 : stack1.fetchingPage), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n<div class=\"no-results hidden\">\n  "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.groups")
  },data:data},helper ? helper.call(depth0, "groups.manage.groups.no_matching_groups", "There are no groups that match your current search term.", options) : helperMissing.call(depth0, "t", "groups.manage.groups.no_matching_groups", "There are no groups that match your current search term.", options)))
    + "\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  